export default "/static/images/build_base_3.png?4239510314dba8a66f0802a2debf6b9e";